import { getLeads } from './getLeads'
import { getAvailableBusinessUnits } from './getAvailableBusinessUnits'
import { getLeadById } from './getLeadById'
import { createLeadTasks } from './createLeadTasks'
import { getReassignationReasons } from './getReassignationReasons'
import {deleteTaskById} from './deleteTaskById'
import {updateTaskById} from './updateTaskById'
import { assignLeads } from './assignLeads'
import { reassignLeads } from './reassignLeads'
import { checkForExistingClient } from './checkForExistingClient'
import { createLeadNote } from './createLeadNote'
import { closeLead } from './closeLead'
import { updateLead } from './updateLead'
import { createLead } from './createLead'
import { getFilters } from './getFilters'
import { getOpportunityData } from './getOpportunityData'
import { changeStateOpportunity } from './changeStateOpportunity'
import { getGroups } from './getGroups'
import { changeStateGroup } from './changeStateGroup'
import { getNamesGroups } from './getNamesGroups'
import { getUserSellerResponsibles } from './getUserSellerResponsibles'
import { getCarLotsGroups } from './getCarLotsGroups'
import { getCampaigns } from './getCampaigns'
import { getBranchOfficesGroup } from './getBranchOfficesGroup'
import { createGroup } from './createGroup'
import { getGroupById } from './getGroupById'
import { updateGroup } from './updateGroup'
import { checkAutoAssign } from './checkAutoAssign'
import { assingLeadAuto } from './assingLeadAuto'
import { createHistoryLeadQuotation } from './createHistoryLead'
import { getMetaFormsData } from './getMetaFormsData'
import { getFormPossibleGroups } from './getFormPossibleGroups'
import { createForm } from './createForm'
import { getFormConfiguration } from './getFormConfiguration'
import { updateForm } from './updateForm'
import { answerMeliQuestion } from './answerMeliQuestion'
import { fetchMessages, sendMessage} from './whatsappConversation'
import { getExtendedLeadsReport } from './getExtendedLeadsReport'
import { getMonthlyLeadsReport } from './getMonthlyLeadsReport'
import { getLeadsTotal } from './getLeadsTotal'
import { getByClientId } from './getByClientId'
import { getOpportunityOrigins } from './getOpportunityOrigins'
import { getCloseReasonByBussinesUnitByCompany } from './getCloseReasonByBussinesUnitByCompany'
import { getGroupsByParticipant } from './getGroupsByParticipant'
import { updateParticipantStates } from './updateParticipantStates'
import { getWhatsAppLines } from './getWhatsAppLines'
import { getCampaignWhatsAppRecipientsTemplate } from './getCampaignWhatsAppRecipientsTemplate'
import { validateCampaignWhatsAppRecipients } from './validateCampaignWhatsAppRecipients'
import { getCampaignDataTable } from './getCampaignDataTable'
import { getCampaignExcel } from './getCampaignExcel'
import { postProcessCampaign } from './postProcessCampaign'
import { getDailySummary } from './getDailySummary'
import { getManagementMetrics } from './getManagementMetrics'
import { changeLeadTemperatureById } from './changeLeadTemperatureById'
import { audit } from './audit'

export const Leads = {
  getLeads,
  getAvailableBusinessUnits,
  getLeadById,
  createLeadTasks,
  getReassignationReasons,
  deleteTaskById,
  updateTaskById,
  assignLeads,
  checkForExistingClient,
  reassignLeads,
  createLeadNote,
  closeLead,
  updateLead,
  createLead,
  getFilters,
  getOpportunityData,
  changeStateOpportunity,
  getGroups,
  changeStateGroup,
  getNamesGroups,
  getUserSellerResponsibles,
  getCarLotsGroups,
  getCampaigns,
  getBranchOfficesGroup,
  createGroup,
  getGroupById,
  updateGroup,
  checkAutoAssign,
  assingLeadAuto,
  createHistoryLeadQuotation,
  getMetaFormsData,
  getFormPossibleGroups,
  createForm,
  getFormConfiguration,
  updateForm,
  answerMeliQuestion,
  fetchMessages,
  sendMessage,
  getLeadsTotal,
  getMonthlyLeadsReport,
  getExtendedLeadsReport,
  getByClientId,
  getOpportunityOrigins,
  getCloseReasonByBussinesUnitByCompany,
  getGroupsByParticipant,
  updateParticipantStates,
  getWhatsAppLines,
  getCampaignWhatsAppRecipientsTemplate,
  validateCampaignWhatsAppRecipients,
  getCampaignDataTable,
  getCampaignExcel,
  postProcessCampaign,
  getDailySummary,
  getManagementMetrics,
  changeLeadTemperatureById,
  audit
};
